<template>
	<div class="p-5">
		<h1>{{ cartName }}</h1>
		<hr />
		<ul class="cart-list">
			<cart-list-large-row
				v-for="row in rows"
				:key="row.id"
				:rowHandler="{
					row,
					quantity: row.quantity,
					static: true,
				}"
				:stock="row.product.stock"
				:currency="row.product.price.currency"
			/>
		</ul>
		<hr class="my-5" />
		<div class="add-to-cart-footer">
			<span class="total">
				Totalpris:
				<span class="sum">
					{{ totalPriceFormatted }}
				</span>
			</span>
			<text-button
				:text="t('BUY_BTN.BUY.BIG')"
				size="large"
				variant="cart"
				@click="addToCart"
			/>
		</div>
		<div class="clearfix" />
		<hr class="my-5">
	</div>
</template>

<script>
import waja from 'waja';
import store from 'datastore';
import { t } from 'datastore/i18n';
import { formatPrice, inStockAnywhere } from 'utils';
import { mapGetters } from 'vuex';
import mq from 'mediaQuery';
import alert from 'alert';

export default {
	store,
	data () {
		return {
			products: null,
			mq,
		};
	},
	beforeRouteEnter (to, frm, next) {
		waja.get('cart/share/' + to.params.products)
			.on('success', res => {
				next(vm => {
					vm.products = res.data.products;
				});
			}).go();
	},
	methods: {
		t,
		addToCart () {
			// @TODO BUY BUTTON CONDITIONS!!!!
			const products = [];
			for (const row of this.rows) {
				const inStock = inStockAnywhere(row.product.stock);
				const fullyBooked = row.product.statusCodes && row.product.statusCodes.indexOf(9/* Tillfälligt fullbokad*/) >= 0;

				if ((! row.product.discontinued || inStock) && ! fullyBooked) {
					products.push({ product: row.product, amount: row.quantity });
				} else if (fullyBooked) {
					alert('En vara du försökt lägga i varukorgen är tillfälligt fullbokad.');
				}
			}
			const extraData = {
				isLoggedIn: this.isLoggedIn,
				source: this.$route.name,
			};
			const trackingData = {
				event: 'addToCart',
				source: this.$route.name,
				stock: this.mq.current > this.mq.sm,
				coupon: true,
			};
			this.$store.dispatch('cart/addMany', {
				products,
				extraData,
				trackingData,
			});
		},
	},
	computed: {
		totalPriceFormatted () {
			if (! this.rows) {
				return 0;
			}
			let currency = null;
			let totalPrice = 0;
			for (const row of this.rows) {
				const inStock = inStockAnywhere(row.product.stock);
				const fullyBooked = row.product.statusCodes && row.product.statusCodes.indexOf(9/* Tillfälligt fullbokad*/) >= 0;

				if ((! row.product.discontinued || inStock) && ! fullyBooked) {
					const price = row.product.price;
					totalPrice += price.price * row.quantity;
					currency = price.currency;
				}
			}
			return formatPrice(totalPrice, currency);
		},
		cartName () {
			return this.$route.query.name || 'Delad kundvagn'; // @TODO översätt
		},
		rows () {
			const rows = [];
			if (! this.products) {
				return rows;
			}
			for (const pXq of this.$route.params.products.split(',')) {
				const split = pXq.split('x');
				const prodId = ~~split[0];
				let product = null;
				for (const prod of this.products) {
					if (prod.id === prodId) {
						product = prod;
						break;
					}
				}
				const quantity = split.length > 1 ? parseInt(split[1]) : 1;
				rows.push({
					quantity,
					product,
				});
			}
			console.log('rows', rows);
			return rows;
		},
		...mapGetters({
			isLoggedIn: 'user/isLoggedIn',
		}),
	},
};
</script>
